import { useState } from 'react'
import { useForm } from 'react-hook-form'

export function useContainerWizard() {
  const [currentStep, setCurrentStep] = useState<number>(0)
  const useFormWizzard = useForm()

  const nextStep = () => {
    setCurrentStep(currentStep + 1)
  }

  const prevStep = () => {
    if (currentStep > 0) {
      setCurrentStep(currentStep - 1)
    }
  }

  return {
    currentStep,
    setCurrentStep,
    useFormWizzard,
    nextStep,
    prevStep,
  }
}
